import axios from '../../../../shared/axios';
import { PagedResponse } from '../../../../shared/models/paged-response';
import { AppDispatch } from '../../../../store';
import * as actionTypes from '../constants/actionTypes';
import { RabbitSignDocument } from '../../models/rabbit-sign-document';
import { GetRabbitSignDocumentsQuery } from '../../models/request-models/get-rabbit-sign-documents-query';
import { RabbitSignDocumentCommandBase } from '../../models/request-models/rabbit-sign-document-command-base';
import { saveAs } from 'file-saver';

const getRabbitSignTemplatesStart = () => {
  return {
    type: actionTypes.GET_RABBIT_SIGN_TEMPLATES_START,
  };
};

const getRabbitSignTemplatesSuccess = (data: any) => {
  return {
    type: actionTypes.GET_RABBIT_SIGN_TEMPLATES_SUCCESS,
    data,
  };
};

const getRabbitSignTemplatesError = (error: any) => {
  return {
    type: actionTypes.GET_RABBIT_SIGN_TEMPLATES_FAIL,
    error,
  };
};

export const getRabbitSignTemplates = (lookupParams: any) => {
  return (dispatch: AppDispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(getRabbitSignTemplatesStart());
      const url = `/rabbit-sign-templates/lookup`;
      axios
        .post(url, lookupParams)
        .then((response) => {
          dispatch(getRabbitSignTemplatesSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getRabbitSignTemplatesError(err));
          reject(err);
        });
    });
  };
};

const saveRabbitSignTemplateStart = () => {
  return {
    type: actionTypes.SAVE_RABBIT_SIGN_TEMPLATE_START,
  };
};

const saveRabbitSignTemplateSuccess = (data: any) => {
  return {
    type: actionTypes.SAVE_RABBIT_SIGN_TEMPLATE_SUCCESS,
    data,
  };
};

const saveRabbitSignTemplateError = (error: any) => {
  return {
    type: actionTypes.SAVE_RABBIT_SIGN_TEMPLATE_FAIL,
    error,
  };
};

export const saveRabbitSignTemplate = (rabbitSignTemplate: any) => {
  return (dispatch: AppDispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(saveRabbitSignTemplateStart());
      const url = `/rabbit-sign-templates/save`;
      axios
        .post(url, rabbitSignTemplate)
        .then((response) => {
          dispatch(saveRabbitSignTemplateSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(saveRabbitSignTemplateError(err));
          reject(err);
        });
    });
  };
};

const deleteRabbitSignTemplateStart = () => {
  return {
    type: actionTypes.DELETE_RABBIT_SIGN_TEMPLATE_START,
  };
};

const deleteRabbitSignTemplateSuccess = (data: any) => {
  return {
    type: actionTypes.DELETE_RABBIT_SIGN_TEMPLATE_SUCCESS,
    data,
  };
};

const deleteRabbitSignTemplateError = (error: any) => {
  return {
    type: actionTypes.DELETE_RABBIT_SIGN_TEMPLATE_FAIL,
    error,
  };
};

export const deleteRabbitSignTemplate = (id: string) => {
  return (dispatch: AppDispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(deleteRabbitSignTemplateStart());
      const url = `/rabbit-sign-templates/delete/${id}`;
      axios
        .delete(url)
        .then((response) => {
          dispatch(deleteRabbitSignTemplateSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(deleteRabbitSignTemplateError(err));
          reject(err);
        });
    });
  };
};

const getRabbitSignTemplateByIdStart = () => {
  return {
    type: actionTypes.GET_RABBIT_SIGN_TEMPLATE_BY_ID_START,
  };
};

const getRabbitSignTemplateByIdSuccess = (data: any) => {
  return {
    type: actionTypes.GET_RABBIT_SIGN_TEMPLATE_BY_ID_SUCCESS,
    data,
  };
};

const getRabbitSignTemplateByIdError = (error: any) => {
  return {
    type: actionTypes.GET_RABBIT_SIGN_TEMPLATE_BY_ID_FAIL,
    error,
  };
};

export const getRabbitSignTemplateById = (id: string) => {
  return (dispatch: AppDispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(getRabbitSignTemplateByIdStart());
      const url = `/rabbit-sign-templates/byid/${id}`;
      axios
        .get(url)
        .then((response) => {
          dispatch(getRabbitSignTemplateByIdSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(getRabbitSignTemplateByIdError(err));
          reject(err);
        });
    });
  };
};

const validateRabbitSignSubscriptionStart = () => {
  return {
    type: actionTypes.VALIDATE_RABBIT_SIGN_SUBSCRIPTION_START,
  };
};

const validateRabbitSignSubscriptionSuccess = (data: any) => {
  return {
    type: actionTypes.VALIDATE_RABBIT_SIGN_SUBSCRIPTION_SUCCESS,
    data,
  };
};

const validateRabbitSignSubscriptionError = (error: any) => {
  return {
    type: actionTypes.VALIDATE_RABBIT_SIGN_SUBSCRIPTION_FAIL,
    error,
  };
};

export const validateRabbitSignSubscription = () => {
  return (dispatch: AppDispatch) => {
    return new Promise((resolve, reject) => {
      dispatch(validateRabbitSignSubscriptionStart());
      const url = `/rabbit-sign/validate-subscription`;
      axios
        .get(url)
        .then((response) => {
          dispatch(validateRabbitSignSubscriptionSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(validateRabbitSignSubscriptionError(err));
          reject(err);
        });
    });
  };
};

const searchRabbitSignDocumentsStart = () => {
  return {
    type: actionTypes.SEARCH_RABBIT_SIGN_DOCUMENTS_START,
  };
};

const searchRabbitSignDocumentsSuccess = (data: PagedResponse<RabbitSignDocument>) => {
  return {
    type: actionTypes.SEARCH_RABBIT_SIGN_DOCUMENTS_SUCCESS,
    data,
  };
};

const searchRabbitSignDocumentsError = (error: any) => {
  return {
    type: actionTypes.SEARCH_RABBIT_SIGN_DOCUMENTS_FAIL,
    error,
  };
};

export const searchRabbitSignDocuments = (request: GetRabbitSignDocumentsQuery) => {
  return (dispatch: AppDispatch) => {
    return new Promise<PagedResponse<RabbitSignDocument>>((resolve, reject) => {
      dispatch(searchRabbitSignDocumentsStart());

      const url = `/rabbit-sign-document/get-documents`;

      axios
        .post(url, request)
        .then((response) => {
          dispatch(searchRabbitSignDocumentsSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(searchRabbitSignDocumentsError(err));
          reject(err);
        });
    });
  };
};

const refreshRabbitSignDocumentStart = () => {
  return {
    type: actionTypes.REFRESH_RABBIT_SIGN_DOCUMENT_START,
  };
};

const refreshRabbitSignDocumentSuccess = (data: RabbitSignDocument) => {
  return {
    type: actionTypes.REFRESH_RABBIT_SIGN_DOCUMENT_SUCCESS,
    data,
  };
};

const refreshRabbitSignDocumentError = (error: any) => {
  return {
    type: actionTypes.REFRESH_RABBIT_SIGN_DOCUMENT_FAIL,
    error,
  };
};

export const refreshRabbitSignDocument = (request: RabbitSignDocumentCommandBase) => {
  return (dispatch: AppDispatch) => {
    return new Promise<RabbitSignDocument>((resolve, reject) => {
      dispatch(refreshRabbitSignDocumentStart());
      const url = `/rabbit-sign-document/refresh`;

      axios
        .get(url, { params: request })
        .then((response) => {
          dispatch(refreshRabbitSignDocumentSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(refreshRabbitSignDocumentError(err));
          reject(err);
        });
    });
  };
};

const sendRabbitSignDocumentReminderStart = () => {
  return {
    type: actionTypes.SEND_RABBIT_SIGN_DOCUMENT_REMINDER_START,
  };
};

const sendRabbitSignDocumentReminderSuccess = (data: any) => {
  return {
    type: actionTypes.SEND_RABBIT_SIGN_DOCUMENT_REMINDER_SUCCESS,
    data,
  };
};

const sendRabbitSignDocumentReminderError = (error: any) => {
  return {
    type: actionTypes.SEND_RABBIT_SIGN_DOCUMENT_REMINDER_FAIL,
    error,
  };
};

export const sendRabbitSignDocumentReminder = (request: RabbitSignDocumentCommandBase) => {
  return (dispatch: AppDispatch) => {
    return new Promise<RabbitSignDocument>((resolve, reject) => {
      dispatch(sendRabbitSignDocumentReminderStart());
      const url = `/rabbit-sign-document/send-reminder`;

      axios
        .post(url, request)
        .then((response) => {
          dispatch(sendRabbitSignDocumentReminderSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(sendRabbitSignDocumentReminderError(err));
          reject(err);
        });
    });
  };
};

const cancelRabbitSignDocumentStart = () => {
  return {
    type: actionTypes.CANCEL_RABBIT_SIGN_DOCUMENT_START,
  };
};

const cancelRabbitSignDocumentSuccess = (data: RabbitSignDocument) => {
  return {
    type: actionTypes.CANCEL_RABBIT_SIGN_DOCUMENT_SUCCESS,
    data,
  };
};

const canelRabbitSignDocumentError = (error: any) => {
  return {
    type: actionTypes.CANCEL_RABBIT_SIGN_DOCUMENT_FAIL,
    error,
  };
};

export const cancelRabbitSignDocument = (request: RabbitSignDocumentCommandBase) => {
  return (dispatch: AppDispatch) => {
    return new Promise<RabbitSignDocument>((resolve, reject) => {
      dispatch(cancelRabbitSignDocumentStart());
      const url = `/rabbit-sign-document/cancel`;

      axios
        .post(url, request)
        .then((response) => {
          dispatch(cancelRabbitSignDocumentSuccess(response.data));
          resolve(response.data);
        })
        .catch((err) => {
          dispatch(canelRabbitSignDocumentError(err));
          reject(err);
        });
    });
  };
};

const downloadExternalRabbitSignDocumentStart = () => {
  return {
    type: actionTypes.DOWNLOAD_EXTERNAL_RABBIT_SIGN_DOCUMENT_START,
  };
};

const downloadExternalRabbitSignDocumentSuccess = () => {
  return {
    type: actionTypes.DOWNLOAD_EXTERNAL_RABBIT_SIGN_DOCUMENT_SUCCESS,
  };
};

const downloadExternalRabbitSignDocumentError = (error: any) => {
  return {
    type: actionTypes.DOWNLOAD_EXTERNAL_RABBIT_SIGN_DOCUMENT_FAIL,
    error,
  };
};

export const downloadExternalRabbitSignDocument = (record: RabbitSignDocument) => {
  return (dispatch: AppDispatch) => {
    dispatch(downloadExternalRabbitSignDocumentStart());

    const url = `/rabbit-sign-document/download`;

    const request: RabbitSignDocumentCommandBase = {
      documentId: record.id,
    };

    axios
      .get(url, { params: request, responseType: 'blob' })
      .then((response) => {
        dispatch(downloadExternalRabbitSignDocumentSuccess());

        const fileName = `${record.title}_${record.rabbitSignFolderId}.zip`;

        const blob = new Blob([response.data], { type: 'application/zip' });

        saveAs(blob, fileName);
      })
      .catch((err) => {
        dispatch(downloadExternalRabbitSignDocumentError(err));
      });
  };
};
